import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
// import Logo from './Logo';
// import { useLogoFont } from '../context/LogoFontContext';

export default function NavBar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  // const { font } = useLogoFont();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-md navbar-dark mb-4" style={{ backgroundColor: 'var(--theme-brand-nav)' }}>
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src="/images/logo-white.png" alt="ChessFlashcards.org" />
        </Link>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setOpen(o => !o)}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>

        <div className={`collapse navbar-collapse${open ? ' show' : ''}`}>
          {user ? (
            <>
              <ul className="navbar-nav me-auto">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/dashboard">My Cards</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/playlists">My Playlists</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/quiz">Quiz Mode</NavLink>
                </li>
                {/*<li className="nav-item">*/}
                {/*  <NavLink className="nav-link" to="/report">Quiz Report</NavLink>*/}
                {/*</li>*/}
                <li className="nav-item">
                  <NavLink className="nav-link" to="/shared-playlists">Shared Playlists</NavLink>
                </li>
                <li className="nav-item">
                  <NavLink className="nav-link" to="/marketplace">Marketplace</NavLink>
                </li>
              </ul>
              <ul className="navbar-nav ms-auto align-items-center">
                <li className="nav-item">
                  <NavLink className="nav-link" to="/preferences">
                    {/*{user.first_name} {user.last_name}*/}
                    {user.nickname}
                  </NavLink>
                </li>
                <li className="nav-item">
                  <button className="btn btn-outline-light btn-sm ms-2" onClick={handleLogout}>
                    Log Out
                  </button>
                </li>
              </ul>
            </>
          ) : (
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink className="nav-link" to="/login">Log In</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/register">Register</NavLink>
              </li>
            </ul>
          )}
        </div>
      </div>
    </nav>
  );
}
